import { UPDATE_SURGE_EVENT, UPDATE_SURGE_EVENT_SUCCESS, UPDATE_SURGE_EVENT_ERROR, UPDATE_SURGE_EVENT_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateEvent = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SURGE_EVENT:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_SURGE_EVENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_SURGE_EVENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_SURGE_EVENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateEvent;
